module.exports = __webpack_public_path__ + "media/site_templates/www.paintersnearme.net.au/images/our_services_2-20f6dcbc04840d67d3679c9928041ad7.jpg";